import React ,{useState,useEffect}from "react";
import Service from "src/api/Service";
import Alert from 'react-bootstrap/Alert';
function AlertComponent(props){
    const [visible, setVisible] = useState(true);
    const [AlertData, setAlertData] = useState([]);
    const [reload, setReload] = useState([]);

    function getAlerts(){

        Service.get("alert_dashboard/alerts/"+props.id,(status,data)=>{
            console.log(data);
          if(status==200){           
            setAlertData(data);  
            setVisible(false);
          }else if(status==400){    
            console.log(data);        
          }
          });
    }

    function setShow(obj){

      console.log(obj);
      Service.post("alertsConfig/changestatus",obj,(status,data)=>{           
      if(status==200){    
        getAlerts();   
        setReload([]);         

      }
     });
      console.log(obj);
    }
    useEffect(()=>{
        getAlerts();    
     
     }, []);

     if(visible){
        <>
        <div>
            ....
        </div>
        </>
     }

     const mystyle = {
        boxShadow: "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 1px 1px;",
        margin: "8px",
        padding:'3px'
      };

     console.log(AlertData.length);
     if(AlertData.length !=0){

        return(
            <>
             <div >            
                
                  {AlertData.map((item, index) => {
                  return(
                    <Alert  style={mystyle} className="alert_panel " key={index} variant="light"   onClose={() => setShow(item)}  dismissible >
                     <p className={'font-weight-bold'} style={{color:item['color']}}> {item['msg']}</p>
                    </Alert>
                    
                  )
                  
                })}             
                 
                
            </div>
            </>
        )
     }else{
        return(
            <>
             <div >           
                
                 
                    <Alert style={mystyle} className="alert_panel " variant="light"   dismissible >
                     <p className={'font-weight-bold'} style={{color:'gray'}}>Alert not found!</p>
                    </Alert>
                
                
            </div>
            </>
        )
     }
   
}

export default AlertComponent;